export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_26.1fc9b9c4.jpg";